import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "WorkflowManager" */ './lazyIndex')
);

export const lazyGetWorkflowSignalManager = new LazyAction(
    lazyModule,
    m => m.getWorkflowSignalManager
);

export { default as signalWorkflowEvent } from './utils/signalWorkflow';
